"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var ERROR_CODES = [400, 403, 404, 500];

var isCodeInvalid = function isCodeInvalid(code) {
  return !code || !ERROR_CODES.includes(code);
};

var getContent = function getContent(code, isGuest) {
  if (isCodeInvalid(code)) {
    return 'error.general';
  }

  if (code === 403 && isGuest) {
    return "error.".concat(code, ".guest");
  }

  return "error.".concat(code);
};

var ErrorPage = function ErrorPage(_ref) {
  var code = _ref.code,
      _ref$isGuest = _ref.isGuest,
      isGuest = _ref$isGuest === void 0 ? false : _ref$isGuest,
      _ref$errorMessage = _ref.errorMessage,
      errorMessage = _ref$errorMessage === void 0 ? '' : _ref$errorMessage,
      _ref$params = _ref.params,
      params = _ref$params === void 0 ? {} : _ref$params;
  var isErrorCodeAvailable = !isCodeInvalid(code);
  var title = isErrorCodeAvailable ? "error.".concat(code, ".title") : 'error.general.title';
  var content = getContent(code, isGuest);
  if (!isErrorCodeAvailable) code = 404;
  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('destination_error', {
      'destination_error--full-height': true
    })
  }, (0, _preact.h)("img", {
    className: "destination_error_image",
    alt: " Error ".concat(code),
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat((0, _globals.default)('basePath'), "images/errors/").concat(code, ".png"))
  }), errorMessage !== null && errorMessage !== void 0 && errorMessage.length ? (0, _preact.h)("div", {
    className: "destination_error_message_description"
  }, errorMessage) : (0, _preact.h)("div", null, (0, _preact.h)("h2", {
    className: (0, _classnames.default)('destination_error_message_header', 'bold', 'qa-page-title')
  }, (0, _preact.h)(_phrase.default, {
    p: title,
    count: params
  })), (0, _preact.h)("div", {
    className: "destination_error_message_description"
  }, (0, _preact.h)(_phrase.default, {
    p: content,
    count: params
  }))));
};

var _default = ErrorPage;
exports.default = _default;